import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { PERMISSIONS } from "helpers/roles"
import CreateRoles from "pages/Roles/create"
import CreateUsers from "pages/Users/create"
import { usePermission } from "hooks/usePermission"

const UserMangementCreate = () => {
  const tabs = ["USER", "ROLE"]
  const { permissions } = useSelector((state) => state.user)
  const [activeTab, setActiveTab] = useState("")
  const navigate = useNavigate()
  const { hasPermission } = usePermission()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.some((perm) =>
        [PERMISSIONS.USER_CREATE, PERMISSIONS.ROLE_CREATE].includes(perm)
      )
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "").toUpperCase()
      if (tabs.includes(hash)) {
        setActiveTab(hash)
      } else {
        const perm = hasPermission(PERMISSIONS.USER_CREATE) ? "USER" : "ROLE"
        setActiveTab(perm)
        window.location.hash = perm
      }
    }

    handleHashChange()
    window.addEventListener("hashchange", handleHashChange)

    return () => window.removeEventListener("hashchange", handleHashChange)
  }, [])

  const HeaderComponent = () => (
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 justify-content-between">
      <div className="investment-trends-tab-section mb-3">
        {hasPermission(PERMISSIONS.USER_CREATE) && (
          <div onClick={() => setActiveTab("USER")} className="tab-box">
            <p
              className={activeTab === "USER" ? "active" : ""}
              style={{ minWidth: "150px" }}
            >
              Create User
            </p>
          </div>
        )}
        {hasPermission(PERMISSIONS.ROLE_CREATE) && (
          <div onClick={() => setActiveTab("ROLE")} className="tab-box">
            <p
              className={activeTab === "ROLE" ? "active" : ""}
              style={{ minWidth: "150px" }}
            >
              Create Role
            </p>
          </div>
        )}
      </div>
    </div>
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={activeTab === "USER" ? "Create User" : "Create Role"}
          />
          {activeTab === "USER" && (
            <CreateUsers HeaderComponent={HeaderComponent} />
          )}
          {activeTab === "ROLE" && (
            <CreateRoles HeaderComponent={HeaderComponent} />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserMangementCreate
